document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('.tabTable .tab-cont').forEach(tab => {

        let leftTabDivs = Array.from(tab.querySelectorAll('.left-tab > div')).map(div => div.getBoundingClientRect().height);

        tab.querySelectorAll('.item').forEach(item =>
            item.querySelectorAll('div').forEach((itemDiv, index) =>
                itemDiv.style.height = `${leftTabDivs[index]}px`
            )
        );
    });
});
